import { render, staticRenderFns } from "./zwbookacivevip.vue?vue&type=template&id=cf4f6670&scoped=true"
import script from "./zwbookacivevip.vue?vue&type=script&lang=js"
export * from "./zwbookacivevip.vue?vue&type=script&lang=js"
import style0 from "./zwbookacivevip.vue?vue&type=style&index=0&id=cf4f6670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4f6670",
  null
  
)

export default component.exports